import React from 'react';
import styled from 'styled-components';
import facebookLogo from '../../img/facebookLogoBottom.svg';
import instagramLogo from '../../img/instagramLogo.svg';
import bitFist from '../../img/bitLogoGrey.svg';
import twitterLogo from '../../img/twitterLogoBottom.svg';
import youtubeLogo from '../../img/youtubeLogo.svg';

const FooterStyle = styled.div`
  font-size: 12px;
  color: #8f8f8f;
  line-height: 14px;
  text-align: center;
  padding: 20px 0 25px 0;
  .socialLinks {
    margin-bottom: 8px;
    a {
      margin-left: 5px;
      display: inline-block;
      width: 36px;
      height: 36px;
    }
  }
  .footerCopyright {
    font-size: 12px;
    color: #8f8f8f;
    line-height: 18px;
  }
  .bandsintownCopyright {
    margin-bottom: 4px;
  }
  .finePrint {
    display: block;
    text-decoration: none;
    color: inherit;
    a {
      text-decoration: underline;
      color: #8f8f8f;
    }
  }
`;

const getYear = () => {
  const dt = new Date();
  return dt.getFullYear()
}

const Footer = () => (
  <FooterStyle>
    <div className="socialLinks">
      <a 
        target= "_blank" 
        rel="noopener noreferrer"  
        href="https://www.facebook.com/bandsintown"
      >
        <img src={facebookLogo} alt="Facebook Logo" />
      </a>
      <a 
        target= "_blank" 
        rel="noopener noreferrer"  
        href="https://instagram.com/bandsintown"
      >
        <img src={instagramLogo} alt="Instagram Logo" />
      </a>
      <a 
        target= "_blank" 
        rel="noopener noreferrer"  
        href="https://www.bandsintown.com/"
      >
        <img src={bitFist} alt="Bandsintown Logo" />
      </a>
      <a 
        target= "_blank" 
        rel="noopener noreferrer" 
        href="https://www.twitter.com/bandsintown"
      >
        <img src={twitterLogo} alt="Twitter Logo" />
      </a>
      <a 
        target= "_blank" 
        rel="noopener noreferrer" 
        href="https://www.youtube.com/bandsintown"
        >
        <img src={youtubeLogo} alt="Youtube Logo" />
      </a>
    </div>
    <div className="bandsintownCopyright">
    Bandsintown Inc. &copy; {getYear()}
    </div>
    <div className="finePrint">
      <a 
        href="https://corp.bandsintown.com/terms"
        target= "_blank" 
        rel="noopener noreferrer"  
        className="underline"
      >
        Terms of Use
      </a> and <a 
        href="https://corp.bandsintown.com/privacy"
        target= "_blank" 
        rel="noopener noreferrer" 
        className="underline"
      > 
       Privacy Policy
      </a>
    </div>
  </FooterStyle>
);

export default Footer;
